import React, { useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import './FeedbackModal.css';

function FeedbackModal({ onClose }) {
    const [email, setEmail] = useState('');
    const [feedback, setFeedback] = useState('');
    const [feedbackType, setFeedbackType] = useState('bug');
    const [showThankYou, setShowThankYou] = useState(false);
    const [errorMessage, setErrorMessage] = useState(''); // Error message state

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate that feedback is not empty
        if (!feedback.trim()) {
            setErrorMessage("Feedback cannot be empty.");
            return;
        }

        try {
            const response = await fetch("/api/feedback/", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    feedbackType: feedbackType,
                    email: email,
                    feedbackContent: feedback,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to send feedback");
            }

            // Clear fields
            setEmail("");
            setFeedback("");
            setFeedbackType("bug");
            setErrorMessage(""); // Clear error message

            // Show thank-you message
            setShowThankYou(true);

        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="feedback-modal-container">
            <div className="row">
                <div className="col-4">
                    <button className="close-button btn-remove-style" onClick={onClose}>
                        <AiOutlineClose size={24} />
                    </button>
                </div>
                <div className="col-4 text-center">
                    <div id="title-container">
                        <span className="font-1">Feedback</span>
                    </div>
                </div>
                <div className="col-4"></div>
            </div>

            {showThankYou ? (
                <div className="text-center">
                    <p className="mt-3 mb-3">Thank you for your feedback!</p>
                    <button type="button" className="btn btn-primary mt-3" onClick={onClose}>
                        Close
                    </button>
                </div>
            ) : (
                <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                    <div className="mb-3">
                        <label htmlFor="feedbackTypeSelect">Type</label>
                        <select
                            className="tkmr-select form-select"
                            value={feedbackType}
                            onChange={e => setFeedbackType(e.target.value)}
                        >
                            <option value="bug">Report Bug</option>
                            <option value="feature">Suggested Feature</option>
                            <option value="others">Others</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label>Email (optional)</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="john.doe@example.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="mb-3">
                        <label>Feedback <span className="text-danger">*</span></label>
                        <textarea
                            className={`form-control ${errorMessage ? 'is-invalid' : ''}`}
                            placeholder="Tell us about the issue or comment!"
                            value={feedback}
                            onChange={e => {
                                setFeedback(e.target.value);
                                if (errorMessage) setErrorMessage(""); // Clear error when user types
                            }}
                            required
                            rows={5}
                            maxLength={500}
                            style={{ resize: "none" }}
                        />
                        {errorMessage && <div className="text-danger mt-1">{errorMessage}</div>}
                    </div>

                    <div className="align-right">
                        <button type="submit" className="btn btn-primary">Send</button>
                    </div>
                </form>
            )}
        </div>
    );
}

export default FeedbackModal;
